import styled from 'styled-components';
import { useCases } from '@/hooks';
import { VoteCard } from '../components/VoteCard';

const Grid = styled.div`
  display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 16px;
`;
const Empty = styled.p` color: ${({ theme }) => theme.color.textMuted}; padding: 24px 0; `;

export function VotingBoardSection() {
  const { cases } = useCases();
  if (cases.length === 0) return <Empty>No cases on the board.</Empty>;
  return <Grid>{cases.map((c) => <VoteCard key={c.id} c={c} />)}</Grid>;
}
